import '../styles/login.css';
import logo from '../assets/AZAREX_logo_BLUE.png';
import { useState } from "react";
import axios from "axios";
import { devURL } from "../constants/constants";
import { useNavigate } from "react-router-dom";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios({
        method: 'get',
        url: `${devURL}/login?username=${username}&password=${password}`
      });

      if(res) {
        localStorage.setItem("user", res.data.user);
        localStorage.setItem("role", res.data.role);
        localStorage.setItem("token", res.data.token);
        navigate("/");
      };
      
    } catch (err) {
      console.log(err)
      setError("Niepoprawny login lub hasło");
    }
  };

  return (
    <div className="loginpage">
      <form onSubmit={handleSubmit}>
        <img src={logo} alt="logo"/>         
        <p>Manager App</p>
        <input
          type="text"
          placeholder="Login"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Hasło"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Zaloguj</button>
        {error && <p style={{ color: "red" }}>{error}</p>}
      </form>
    </div>
  );
}
